__turbopack_context__.v({
  "centerHit": "video-player-module-scss-module__0xsLAW__centerHit",
  "controls": "video-player-module-scss-module__0xsLAW__controls",
  "controlsRow": "video-player-module-scss-module__0xsLAW__controlsRow",
  "glassIconButton": "video-player-module-scss-module__0xsLAW__glassIconButton",
  "leftButtons": "video-player-module-scss-module__0xsLAW__leftButtons",
  "poster": "video-player-module-scss-module__0xsLAW__poster",
  "rightButtons": "video-player-module-scss-module__0xsLAW__rightButtons",
  "root": "video-player-module-scss-module__0xsLAW__root",
  "rootControls": "video-player-module-scss-module__0xsLAW__rootControls",
  "timeline": "video-player-module-scss-module__0xsLAW__timeline",
  "timelineFill": "video-player-module-scss-module__0xsLAW__timelineFill",
  "timelineHandle": "video-player-module-scss-module__0xsLAW__timelineHandle",
  "timelineInput": "video-player-module-scss-module__0xsLAW__timelineInput",
  "video": "video-player-module-scss-module__0xsLAW__video",
});
